import React from 'react'
import { Navbar2 } from '../navbar/Navbar'
import './message.css'
import { ReactComponent as Circleplus } from '../icons/circle-plus-solid.svg';

export default function Messages() {

  const useFetch = () => {
    const defaultValue = []
    const[data,setData] = React.useState(defaultValue)

    React.useEffect(() => {
        const getUsers = async function () {
            const respData = await (
                await fetch("https://api.github.com/users")
                ).json()
            setData(respData)
        }
        getUsers()
    }, [])
  return data
}
const data = useFetch()

  return (
    <div className='fbmessage bor'>
      <Navbar2 />

      <div className='messagescntr bor'>
        {data.map((user, index) => {
          return(
            <div className='messages'  key={user.id}>
            <div className='msg-img'>
              <img src={user.avatar_url} alt={user.avatar_url}/>
              <div className='dotcntr'>
                <div className='dotstatus'></div>
              </div>
            </div>
            <h3>{user.login}</h3>
          </div>
          )
        })}
      </div>

      <div className='messag-search-friend'>
        <input type='text' placeholder='Search for friends'/>
        <Circleplus fill='#448aff'/>
      </div>

    </div>
  )
}
